import { useEventListener, Scope } from './EventListener'

interface Config {
  key: string | string[]
  preventDefault?: boolean
  stopPropagation?: boolean
  handler: (event: any) => void
  scope?: Scope
}

const createHandler = ({
  key,
  handler,
  preventDefault,
  stopPropagation,
}: Config) => (event: KeyboardEvent) => {
  const keys = Array.isArray(key) ? key : [key]
  if (keys.includes(event.key)) {
    handler(event)
    preventDefault && event.preventDefault()
    stopPropagation && event.stopPropagation()
  }
}

export const useHotkey = ({
  dependencies = [],
  key,
  handler = () => {},
  scope = window,
  preventDefault = false,
  stopPropagation = false,
}: Config & { dependencies?: any[] }) => {
  useEventListener({
    dependencies,
    event: 'keydown',
    handler: createHandler({
      key,
      handler,
      preventDefault,
      stopPropagation,
    }),
    scope,
  })
}
